import { useState } from "react"
import { Image } from "lucide-react"
import { useInViewport } from "./useInViewport"
import { CoverImageElementData } from "./types"

export const CoverImageElement: React.FC<CoverImageElementData> = ({
  imageUrl,
  style,
  alt = "Cover image",
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [imgRef, isInView] = useInViewport({ threshold: 0.1 })

  return (
    <div ref={imgRef} className="absolute overflow-hidden" style={style}>
      {imageUrl && isInView ? (
        <img
          src={imageUrl}
          alt={alt}
          className="w-full h-full object-contain transition-opacity duration-200"
          style={{ opacity: isLoaded ? 1 : 0 }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(true)}
        />
      ) : (
        <div className="h-full w-full flex justify-center border-neutral-300 bg-neutral-50 items-center">
          <Image className="h-5 w-5 text-neutral-300" />
        </div>
      )}
    </div>
  )
}
